module.exports = "/images/extreme-fire@3x.png?d57b19efb58e38d85f5161b95027b3ed";